import { SvgIcon, SvgIconProps } from '@mui/material'

export const LiveIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'white' }} {...props}>
    <g clipPath="url(#live)">
      <path
        d="M21 6H13.41L16.7 2.71L16 2L12 6L8 2L7.29 2.71L10.59 6H3C1.9 6 1 6.89 1 8V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V8C23 6.89 22.1 6 21 6ZM21 20H3V8H21V20ZM9 10V18L16 14L9 10Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="live">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)
